'use client';

import {
  SkillsContentView,
  useSkillsContentModel,
} from '../tabs/SkillsContent';
import { useSettingsTabHeaderActions } from './settingsTabHeaderContext';

export function SkillsSettingsTabContent() {
  const model = useSkillsContentModel();
  useSettingsTabHeaderActions(model.toolbarActions);
  return <SkillsContentView model={model} />;
}
